import React from 'react';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { Panel } from '@jutro/components';

import CreateAccountFAQItem from '../CreateAccountFAQItem/CreateAccountFAQItem';
import metadata from './CreateAccountFAQ.metadata.json5';
import faqData from './CreateAccountFAQ.data.json';
import styles from './CreateAccountFAQ.module.scss';

function CreateAccountFAQ() {
    const resolvers = {
        resolveComponentMap: {
            createaccountfaqitem: CreateAccountFAQItem
        }
    };

    const overrideProps = {
        faqIterable: {
            data: faqData.faqs
        }
    };

    return (
        <>
            <Panel
                id="createAccountFAQContainer"
                fluid
                className={styles.faqSection}
            >
                {renderContentFromMetadata(
                    metadata.componentContent,
                    overrideProps,
                    resolvers
                )}
            </Panel>
        </>
    );
}

export default CreateAccountFAQ;
